import { render, staticRenderFns } from "./MaterialDetailCard.vue?vue&type=template&id=4f621724&scoped=true&"
import script from "./MaterialDetailCard.vue?vue&type=script&lang=js&"
export * from "./MaterialDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDetailCard.vue?vue&type=style&index=0&id=4f621724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f621724",
  null
  
)

export default component.exports